import { Box, Paper as PaperMui, styled, Tabs as TabsMui } from "@mui/material"
import { PageTitle as TitlePageComponents } from "components/PageTitle"

export const ContainerPage = styled(PaperMui)(({ theme }) => ({
  maxWidth: "1400px",
  margin: "0 auto 0 auto",
  padding: "1rem",
  height: "calc(100vh - 6.25rem - 5px)",
  display: "flex",
  flexDirection: "column",
  background: "transparent",
  boxShadow: "none",
}))

export const ContainerHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  marginBottom: "2rem",
  [theme.breakpoints.between(0, 460)]: {
    flexDirection: "column",
    alignItems: "flex-start",
  },
}))

export const TitlePage = styled(TitlePageComponents)({
  display: "flex",
  alignItems: "center",
  gap: "0.25rem",
})

export const Tabs = styled(TabsMui)(({ theme }) => ({
  marginBottom: "2.5rem",
  "& .MuiTab-wrapper": {
    fontWeight: 500,
    textTransform: "none",
    fontSize: "1.1rem",
  },
  "& .MuiTabs-indicator": {
    height: "5px",
    backgroundColor: "#567B0D",
    border: "none",
    borderRadius: "5px",
  },
  "& .MuiTab-textColorInherit.Mui-selected": {
    color: "#353535",
  },
  "& .MuiTab-textColorInherit": {
    color: "#A3A3A3",
  },
}))
